module.exports = __webpack_public_path__ + "img/credit-img-09.e8d697ca.png";